module.exports = __webpack_public_path__ + "static/media/icon-valuepropositioncanvas.6b342f6f.svg";